import React from "react";
import { Link } from "react-router-dom";

export default function DeleteAccount() {
  return (
    <div
      data-testid="delete-account-page"
      style={{
        maxWidth: 760,
        margin: "40px auto",
        padding: 24,
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif",
        color: "#1a1a2e",
        lineHeight: 1.6,
      }}
    >
      <h1 style={{ fontSize: 28, marginBottom: 16, color: "#0B1F4B" }}>
        Exclusão de Conta – JATOO
      </h1>

      <p>
        A JATOO permite que usuários solicitem a exclusão permanente da conta e
        dos dados pessoais associados à plataforma.
      </p>

      <p>Para solicitar a exclusão da conta, envie um e-mail para:</p>

      <p>
        <a
          href="mailto:contato@jatoo.app.br?subject=Solicita%C3%A7%C3%A3o%20de%20exclus%C3%A3o%20de%20conta"
          data-testid="delete-account-email-link"
          style={{ color: "#1877F2", fontWeight: 600 }}
        >
          contato@jatoo.app.br
        </a>
      </p>

      <p>
        <strong>Assunto do e-mail:</strong>
        <br />
        "Solicitação de exclusão de conta"
      </p>

      <p>
        O processamento da solicitação poderá ocorrer em até 90 dias após o
        recebimento do pedido.
      </p>

      <p>
        Para informações completas sobre tratamento de dados, retenção e
        exclusão, consulte nossa Política de Privacidade.
      </p>

      <div style={{ marginTop: 32 }}>
        <Link
          to="/privacidade"
          data-testid="delete-account-privacy-link"
          style={{
            display: "inline-block",
            padding: "12px 24px",
            background: "#1877F2",
            color: "#fff",
            textDecoration: "none",
            borderRadius: 8,
            fontWeight: 600,
          }}
        >
          Ver Política de Privacidade
        </Link>
      </div>
    </div>
  );
}
